/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    import IMeevoMessengerQuickAnswer = Meevo.Model.IMeevoMessengerQuickAnswer;

    class ConversationBottomContoller implements ng.IComponentController {
        static $inject = [];

        public quickAnswersList: IMeevoMessengerQuickAnswer[];
        public isDisabled: boolean;
        public isInTransferMode: boolean;
        public isMessagesToTransferExist: boolean;
        public sendMessage: ({ msg: string }) => void;
        public transferMessages: () => void;
        public cancelTransferMessage: () => void;
        public activeMessenger: MessengersEnum;
        private currentInputText: string;

        private isQuicknswersVisible: boolean = false;
        private isSliderToggled: boolean = false;
        private meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        private securityParts = Meevo.Components.Common.SecurityParts;
        private messageLengthLimit: number;
        private splitMessagesCountLimit: number;

        constructor() { }

        $onInit() { }

        public quickResponseSelected(quickResponse: string): void {
            this.currentInputText = quickResponse;

            const inputElement = angular.element('.meevoMessenger-message-input'),
                cursorIndex = inputElement.prop('selectionStart');
            inputElement.focus();

            // Prevent cursor jump when new response populates input field
            _.defer(() => {
                if (cursorIndex < inputElement.length - 1) {
                    inputElement.prop({
                        'selectionStart': cursorIndex,
                        'selectionEnd': cursorIndex
                    });
                }
            });

            this.isQuicknswersVisible = false;
        }

        private onMessageSend(msg: string): void {
            this.sendMessage({ msg })
            this.currentInputText = '';
        }

        private toogleSlider(): void {
            this.isSliderToggled = !this.isSliderToggled;
        }

        private toggleQuickResponses(): void {
            this.isQuicknswersVisible = !this.isQuicknswersVisible;
        }

        private onTransferMesssages() {
            this.transferMessages();
        }

        private onCancelTransferMode(): void {
            this.cancelTransferMessage();
        }

        get oneMessageLenghtLimit(): number {
            return this.messageLengthLimit ? this.messageLengthLimit : Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_LENGTH_LIMIT;
        }

        get maxMessageLimit(): number {
            const splitter = this.splitMessagesCountLimit ? this.splitMessagesCountLimit : Meevo.Plugins.MeevoMessenger.Constants.SPLIT_MESSAGES_COUNT_LIMIT;
            const messageLengthLimit = this.messageLengthLimit ? this.messageLengthLimit : Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_LENGTH_LIMIT;
            return messageLengthLimit * splitter;
        }

        get messengerWriteKey(): string {
            if (this.activeMessenger == MessengersEnum.MeevoMessengerTextel) {
                return this.meevoSecurityKeys.INTEGRATION_TEXTEL_TAB_CHATWINDOW_SENDMESSAGE + this.securityParts.KEY_PART_WRITE;
            }

            return this.meevoSecurityKeys.MANAGEMENT_MEEVOMESSENGER_ARRIVALS_CHATWINDOW_SENDEMESSAGE + this.securityParts.KEY_PART_WRITE;
        }

        get messengerEnum() {
            return MessengersEnum;
        }
    }

    class ConversationBottomComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/conversationBottom/conversationBottom.template.html';
        controller = ConversationBottomContoller;
        controllerAs = 'conversationBottom';
        bindings = {
            quickAnswersList: '=',
            isDisabled: '=',
            isInTransferMode: '=?',
            isMessagesToTransferExist: '=?',
            sendMessage: '&',
            transferMessages: '&?',
            cancelTransferMessage: '&?',
            activeMessenger: '<',
            messageLengthLimit: '@',
            splitMessagesCountLimit: '@',
            isClientOptedOut: '<',
            showClientMobileTypeWarning: '<',
            currentInputText: '<'
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('meevoMessengerConversationBottom', new ConversationBottomComponent());

}

